module.exports = react/lib/ExecutionEnvironment;


//////////////////
// WEBPACK FOOTER
// external "react/lib/ExecutionEnvironment"
// module id = 1333
// module chunks = 3